
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noResult",
      function () {
        return require("private-next-pages/noResult.js");
      }
    ]);
  